import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import Swal from 'sweetalert2';

type BtnTypes = 'primario' | 'secundario' | 'cadastro' | 'upload';

@Component({
  selector: 'app-botao',
  templateUrl: './botao.component.html',
  styleUrls: ['./botao.component.scss']
})
export class BotaoComponent {
  @Input() type: BtnTypes = 'primario';
  @Input() width: string = '';
  @Input() bgColor: string = '';
  @Input() color: string = '';
  @Input() border: string = '';
  @Input() text: string = '';
  @Input() icon: string = '';
  @Input() disabled: boolean = false;
  @Output() fileSelected = new EventEmitter<string>();
  @ViewChild('fileInput', { static: false }) fileInput:
    | ElementRef<HTMLInputElement>
    | undefined;

  file: File | null = null;
  fileSrc: string | ArrayBuffer | null = null;
  constructor(
    private router: Router,
    public swalAlert: SwalAlertService
  ) {}

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (this.isFileTypeAllowed(file)) {
      this.file = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.fileSrc = reader.result;
        this.fileSelected.emit(reader.result as string);
        this.resetFileInput();
      };
      reader.readAsDataURL(this.file);
    } else {
      this.swalAlert.showAlert(
        'Atenção!',
        'Tipo de arquivo não permitido. Apenas arquivos no formato .xlsx são aceitos.',
        'warning',
        false,
        false,
        undefined
      );

      if (this.fileInput) this.fileInput.nativeElement.value = '';
    }
  }

  isFileTypeAllowed(file: File): boolean {
    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    return fileExtension === 'xlsx';
  }

  resetFileInput() {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
    this.file = null;
    this.fileSrc = null;
  }
}
